/**
 * Validates email address format using basic regex
 * @param {string} address - Email address to validate
 * @returns {boolean} True if email format is valid
 */
function isValidEmailAddress(address) {
  return !!address.match(/.+@.+/);
}

/**
 * Formats cart items into readable quantity string for display
 * @param {Array} items - Array of cart items
 * @returns {string} Formatted string with quantities and variations
 */
const cartItemQuantity = (items) => {
  return items.map((item) => `${item.quantity}x ${item.title}${
    item.variation?.title ? `(${item.variation.title})` : ""
  }`).join("\n");
};

/**
 * Calculates total price for a food item including variation and addons
 * @param {Object} food - Food item with variation and addons
 * @returns {number} Total calculated price
 */
function calculatePrice(food) {
  // Items from shop-type stores can come back without a variation or addons,
  // and reading straight through them throws while rendering an order.
  var foodPrice = food.variation?.price ?? 0;
  // Add prices of all selected addons
  (food.addons ?? []).forEach((addons) => {
    (addons.options ?? []).forEach((addon) => {
      foodPrice += addon.price;
    });
  });
  return foodPrice;
}

/**
 * Calculates distance between two geographic points using Haversine formula
 * @param {number} latS - Source latitude
 * @param {number} lonS - Source longitude
 * @param {number} latD - Destination latitude
 * @param {number} lonD - Destination longitude
 * @returns {number} Distance in kilometers
 */
function calculateDistance(latS, lonS, latD, lonD) 
{
  var R = 6371; // Earth's radius in kilometers
  var dLat = toRad(latD-latS);
  var dLon = toRad(lonD-lonS);
  var lat1 = toRad(latS);
  var lat2 = toRad(latD);

  // Haversine formula calculation
  var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c;
  return d;
}

/**
 * Converts numeric degrees to radians for trigonometric calculations
 * @param {number} Value - Degrees to convert
 * @returns {number} Value in radians
 */
function toRad(Value) 
{
    return Value * Math.PI / 180;
}

export { isValidEmailAddress, cartItemQuantity, calculatePrice, calculateDistance };
